import React from 'react';

/**
 * Badge component for displaying status labels
 * @param {Object} props - Component props
 * @param {('primary'|'success'|'warning'|'error'|'info')} [props.variant='primary'] - Badge style variant
 * @param {React.ReactNode} props.children - Badge content
 * @param {string} [props.className] - Additional CSS classes
 */
const Badge = ({ variant = 'primary', children, className = '' }) => {
  const getBadgeClasses = (variant) => {
    switch (variant) {
      case 'primary':
        return 'bg-primary-light text-primary rounded-md';
      case 'success':
        return 'bg-success bg-opacity-10 text-success';
      case 'warning':
        return 'bg-warning bg-opacity-10 text-warning';
      case 'error':
        return 'bg-error bg-opacity-10 text-error';
      case 'info':
        return 'bg-info bg-opacity-10 text-info';
      default:
        return 'bg-gray-100 tertiary-text-color';
    }
  };

  return (
    <span
      className={`inline-flex items-center px-2.5 py-1 rounded-md text-xs font-medium ${getBadgeClasses(
        variant,
      )} ${className}`}
    >
      {children}
    </span>
  );
};

export default Badge;
